import { redirect, RouteObject } from 'react-router-dom'
import axios from 'axios'
import { base_url } from 'env'

// Import the pages we will create in the next steps
import BadgesPage from 'pages/Badges/Badges'
import BadgeCreatePage from 'pages/Badges/BadgeCreate'
import BadgePreviewPage from 'pages/Badges/BadgePreview'
import BadgeEditPage from 'pages/Badges/BadgeEdit'

// A common loader to get a single badge's data
const badgeLoader = async ({ params }: { params: { id?: string } }) => {
 try {
    const response = await axios.get(`${base_url}/badge/${params.id}`)
    return response.data
  } catch (error) {
    console.error(error)
    return redirect('/badges') // Redirect to list on error
  }
}

export const BadgeRoutes: RouteObject[] = [
  {
    path: '/badges',
    loader: async () => {
      try {
        const response = await axios.get(base_url + '/badge/')
        return response.data
      } catch (error) {
        console.error(error)
        return [] // Return empty array on error
      }
    },
    element: <BadgesPage />,
  },
  {
    path: '/badge/create',
    element: <BadgeCreatePage />,
  },
  {
    path: '/badge/:id',
    loader: badgeLoader,
    element: <BadgePreviewPage />,
  },
  {
    path: '/badge/:id/edit',
    loader: badgeLoader, // Reuse the same loader
    element: <BadgeEditPage />,
  },
]
